import { toDateStr } from './meetingsEventsView';

export const CANONICAL_STATUSES = ['Open', 'In Progress', 'Discussed', 'Parked', 'Resolved'];
export const LEGACY_STATUSES = ['Started', 'Hold', 'Completed'];
export const CLOSED_STATUSES = ['Resolved', 'Closed', 'Completed', 'Resolved/Closed'];
export const PRIORITIES = ['Low', 'Medium', 'High'];
export const MINISTRY_LEAD_TEMPLATE = 'm-ministry-lead-meeting';

const PRIORITY_RANK = { high: 0, medium: 1, low: 2 };

export function isClosedStatus(status) {
  const value = String(status || '').trim().toLowerCase();
  return CLOSED_STATUSES.some((name) => name.toLowerCase() === value);
}

export function isClosedHotIssue(issue) {
  return isClosedStatus(issue?.status);
}

export function findNextMinistryLeadMeeting(events, now = new Date()) {
  const today = toDateStr(now);
  return (Array.isArray(events) ? events : [])
    .filter((event) => event && event.templateKey === MINISTRY_LEAD_TEMPLATE && toDateStr(event.date) >= today)
    .sort((a, b) => new Date(a.date) - new Date(b.date))[0] || null;
}

export function sortActiveHotIssues(issues) {
  return [...(issues || [])].sort((a, b) => {
    const rank = (issue) => {
      const value = PRIORITY_RANK[String(issue?.priority || '').trim().toLowerCase()];
      return value == null ? 3 : value;
    };
    const byPriority = rank(a) - rank(b);
    if (byPriority !== 0) return byPriority;
    const byDate = new Date(a?.date || 0).getTime() - new Date(b?.date || 0).getTime();
    if (byDate !== 0) return byDate;
    return String(a?.issue || '').localeCompare(String(b?.issue || ''));
  });
}

export function closedYear(issue, now = new Date()) {
  const stamp = issue?.closedAt || issue?.date;
  const year = stamp ? new Date(stamp).getFullYear() : NaN;
  return Number.isFinite(year) ? year : now.getFullYear();
}

export function statusChoices(issue, statusOptions) {
  const legacy = new Set(LEGACY_STATUSES.map((status) => status.toLowerCase()));
  const extras = (statusOptions || []).filter((status) => {
    const value = String(status || '').trim();
    if (!value) return false;
    const lower = value.toLowerCase();
    if (CANONICAL_STATUSES.some((name) => name.toLowerCase() === lower)) return false;
    return !legacy.has(lower);
  });
  const choices = [...CANONICAL_STATUSES, ...extras];
  const current = String(issue?.status || '').trim();
  if (current && !choices.some((status) => status.toLowerCase() === current.toLowerCase())) {
    choices.push(current);
  }
  return choices;
}

export function notesNewestFirst(updates) {
  return [...(Array.isArray(updates) ? updates : [])].sort(
    (a, b) => new Date(b?.createdAt || 0).getTime() - new Date(a?.createdAt || 0).getTime()
  );
}

export function emptyHotIssueForm(now = new Date()) {
  return {
    date: toDateStr(now),
    personnel: '',
    issue: '',
    details: '',
    poc: '',
    nextStep: '',
    priority: '',
    status: 'Open',
  };
}

export function hotIssueToForm(item, now = new Date()) {
  return {
    date: toDateStr(item?.date) || toDateStr(now),
    personnel: item?.personnel || '',
    issue: item?.issue || '',
    details: item?.details || '',
    poc: item?.poc || '',
    nextStep: item?.nextStep || '',
    priority: item?.priority || '',
    status: item?.status || 'Open',
  };
}

export function formatIssueDate(value) {
  if (!value) return '';
  return new Date(value).toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatIssueDateShort(value) {
  if (!value) return '';
  return new Date(value).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatUpdateWhen(value) {
  if (!value) return '';
  return new Date(value).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
